export default function Spinner(props) {
  return <div className={props.show ? "spinner active" : ""} aria-hidden={!props.show} />;
}
